import React, {Component} from 'react';
import {Label, UncontrolledTooltip} from "reactstrap";
import './Deal.css';
import {DatePicker, Form} from "antd";
import {deepCopyObject, showAxiosError, trimObject, uploadImagesAndReplaceInHtml} from "../../util/Helpers";
import {validateComponent, validateField} from "../../common/validation";
import BraftEditor from 'braft-editor';
import 'braft-editor/dist/index.css';
import moment from "moment";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import Alert from "react-s-alert";
import LoadingIndicator from "../../common/LoadingIndicator";

class DealForm extends Component {

	constructor(props) {
		super(props);
		this.state = {
			error: {},
			mode: 'create',
			key: Math.random().toString(36),
			page: 0,
			size: 10,
			manual: false,
			loading: false,
            isLoading: false,
			deal: {
                id: null,
				title:null,
				text: null,
				startDate: null,
				endDate: null,
				dealAttachments:[],
                postId:null,
			},
			editorState : null//BraftEditor.createEditorState(null )
		};

		this.validateClass = this.validateClass.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.validateField = this.validateField.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.saveDeal = this.saveDeal.bind(this);
		this.cancelProcess = this.cancelProcess.bind(this);
		this.onChangeEditor=this.onChangeEditor.bind(this);
        this.validatedealInfo=this.validatedealInfo.bind(this);
        this.onEditorStateChange=this.onEditorStateChange.bind(this);
		this.handleEditorChange=this.handleEditorChange.bind(this);
        this.transformHtml=this.transformHtml.bind(this);
	}

	onEditorStateChange(editorState) {
		console.log(editorState);
		this.setState({
			editorState,
		});
	};

	async componentDidMount() {
		if (this.props.selectedDeal) {

			let selectedDeal = deepCopyObject(this.props.selectedDeal);
			const  htmlContent  =  this.props.selectedDeal ? this.props.selectedDeal.text: "";
            selectedDeal.startDate =
                selectedDeal.startDate
                    ? moment.utc(selectedDeal.startDate).startOf("day")
                    : null;

            selectedDeal.endDate =
                selectedDeal.endDate
                    ? moment.utc(selectedDeal.endDate).startOf("day")
                    : null;
            this.setState({
				mode: this.props.mode,
				deal: selectedDeal,
				editorState : BraftEditor.createEditorState(htmlContent),
			});

		}
	}

    validatedealInfo(){
        let dealInfo=this.state.deal;
        let selectedGroups=this.state.selectedGroups;
        let errorMessage='';
        if(dealInfo.title===null || dealInfo.title.toString().trim()==='')
        {
            errorMessage += 'Başlık Boş Olamaz!</br>'  ;
        }
        if(dealInfo.text===null || dealInfo.text.toString().trim()==='')
        {
            errorMessage += 'Anlaşma Metni Boş Olamaz!</br>'  ;
        }
        if(dealInfo.startDate===null || dealInfo.startDate.toString().trim()==='')
        {
            errorMessage += 'Başlangıç Tarihi Seçiniz!</br>'  ;
        }

        // console.log(errorMessage);
        return errorMessage;
    }

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let value = e.target.value;
		let result = validateField(rule, boundary, value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	onChangedeal(e) {
		this.setState({
			deal: {
				...this.state.deal,
				[e.target.name]: e.target.value
			}
		})
	}

	onChangeEditor( event, editor ) {
		let dealInfo=this.state.deal;
		dealInfo['text']=editor.getData().trim();
		this.setState({dealInfo });
	}

    transformHtml = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        doc.querySelectorAll("div.media-wrap.image-wrap").forEach((div) => {
            const classes = div.getAttribute("class") && div.getAttribute("class").split(/\s+/) || [];

            // media-wrap ve image-wrap her zaman kalacak
            const newClasses = ["media-wrap", "image-wrap"];
            let alignClass = "";

            // hizalama class'ını normalize et
            if (classes.includes("align-right")) {
                alignClass = "alignright";
            } else if (classes.includes("align-left")) {
                alignClass = "alignleft";
            } else if (classes.includes("align-center")) {
                alignClass = "aligncenter";
            }

            if (alignClass) {
                newClasses.push(alignClass);
            }

            // div class'ını güncelle
            div.setAttribute("class", newClasses.join(" "));

            // içindeki img'lere de aynı alignClass ekle
            div.querySelectorAll("img").forEach((img) => {
                const imgClasses = ["media-wrap", "image-wrap"];
                if (alignClass) {
                    imgClasses.push(alignClass);
                }
                img.setAttribute("class", imgClasses.join(" "));
            });
        });

        const innerHtml = doc.body.innerHTML;

        // Dış kapsayıcı ile sarmala
        return `<div style="padding-bottom: 100px; margin: auto; width: 90%; display: flex; justify-content: center; flex-direction: column;">${innerHtml}</div>`;
    };


    handleEditorChange  =  (editorState) => {
		this.setState ( { editorState} )
		let dealInfo=this.state.deal;
        dealInfo['text']=editorState.toHTML();
		this.setState({ dealInfo });
	}

	onChangeDate(name,value) {
		let dealInfo=this.state.deal;
		dealInfo[name]=value;
		this.setState({ dealInfo });
		// console.log(dealInfo);
	}

	onSelectInfoChange(e){
		let selectedGroups=this.state.selectedGroups;
		console.log("e",e);
		console.log("selectedGroups",selectedGroups);
		if(e===null) {
			selectedGroups=[];
		}
		else {
			selectedGroups=[];
			selectedGroups=e.slice();
		}
		this.setState({selectedGroups });
	}

	async saveDeal() {
        let self = this;
        let params;
        let data;
        let message;
        let validity = this.validatedealInfo();
        if (validity ==='') {
            self.setState({isLoading:true});
            let deal = deepCopyObject(this.state.deal);
            deal=trimObject(deal);
            deal.text = await uploadImagesAndReplaceInHtml(deal.text);
            console.log("deal:: ",deal);
            data = deal;
            if (deal.id === null) {
                message = 'Anlaşma Başarıyla Kaydedildi.'
                params = {
                    url: API_BASE_URL + "/deal",
                    data: data,
                    method: 'post'
                };
            } else {
                message = 'Anlaşma Başarıyla Güncellendi.'
                params = {
                    url: API_BASE_URL + "/deal",
                    data: data,
                    method: 'patch'
                };
            }
            request(params).then(() => {
                Alert.success(
                    message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                self.setState({isLoading:false});
                this.cancelProcess();
            }).catch(function (error) {
                self.setState({isLoading:false});
                showAxiosError(error);
            });
        }
        else{
            Alert.error(
                validity, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 20000
                });
        }
	}


/*	clearForm() {
		this.setState({
			key: Math.random().toString(36),
			selectedRole: null,
			user: {
				firstName: null,
				lastName: null,
				username: null,
				email: null,
				roleId: null,
				branchList: []
			}
		})
	}*/

	cancelProcess() {
		this.props.cancelProcess();
	}


	render() {
		let tStartDate = this.state.deal.startDate ? {value: this.state.deal.startDate} : {};
		let tEndDate = this.state.deal.endDate ? {value: this.state.deal.endDate} : {};

		return (
			<div>
				{
					(this.state.isLoading)&&
					<div className="loader">
						<LoadingIndicator/>
					</div>
				}

				<div className="card-body mt-1">
					<Form>
					<div className="FormRenk col-sm-12">
						<span className="form-title">Anlaşma Bilgileri</span>
						<div className='col-sm-12 row'>
								<div className="col-sm-2">
									<label>Başlık *</label>
								</div>
								<div className="col-sm-10">
									<div className={"form-group" + this.validateClass('tTitle')}>
										<input className="form-control"
											   type="text"
											   name="title"
											   id="tTitle"
											   data-vlength="1,255"
											   onBlur={this.validateField}
											   ref="tTitle"
											   style={{  height:30}}
											   value={this.state.deal.title}
											   onChange={(e) => this.onChangedeal(e)}/>
										{this.validateMessage('tTitle') !== "" &&
										<UncontrolledTooltip placement="right" target="tTitle" delay={0}>
											{this.validateMessage("tTitle")}
										</UncontrolledTooltip>}
									</div>
								</div>

						</div>
						{/* TEXT ROW */}

						<div className='col-sm-12 row'>
								<div className="col-sm-2">
									<label>Metin *</label>
								</div>
								<div className="col-sm-10">
									<div className={"form-group" + this.validateClass('tAdres')}>
										< BraftEditor
											value = { this.state.editorState }
											onChange = { this.handleEditorChange }
											language={'tr'}
                                        />
										{this.validateMessage('tText') !== "" &&
										<UncontrolledTooltip placement="right" target="tText" delay={0}>
											{this.validateMessage("tText")}
										</UncontrolledTooltip>}
									</div>
								</div>
						</div>

						<div className="row">
							<Label className="col-sm-2">Baş. Tarihi *</Label>
							<div className={"col-sm-10 form-group" + this.validateClass('tStartDate')}>
								<DatePicker {...tStartDate}
                                    className="basic-single"
                                    placeholder="Tarih seçiniz."
                                    classNamePrefix="select"
                                    format= "DD.MM.YYYY"
                                    name="startDate"
                                    id="tStartDate"
                                    ref="tStartDate"
                                    style={{ width: 250 , height:30}}
                                    inputProps={{'vdata': "required"}}
                                    onChange={(dateString)=>this.onChangeDate("startDate",dateString)}/>
								{this.validateMessage('tStartDate') !== "" &&
								<UncontrolledTooltip placement="right" target="tStartDate" delay={0}>
									{this.validateMessage("tStartDate")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
					</Form>
				</div>

				{/* CARD FOOTER */}
				<div className="modal-footer">
					<div className='col-sm-12 row' id="deleteModal">
						<div className='col-sm-2'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#9e9e9e', padding: '10px 54px 10px 23px',width:"150px"}}
									rel="tooltip" className="TekBtn vazgec "
									onClick={this.cancelProcess}>
								İptal
							</button>
						</div>
						<div className="col-sm-8"></div>
						<div className='col-sm-2'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{
										background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
										float: 'right', padding: '10px 54px 10px 23px', width:"150px"
									}}
									rel="tooltip" className="TekBtn kaydet"
									onClick={() => this.saveDeal()}>Kaydet
							</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default DealForm;


// WEBPACK FOOTER //
// ./src/page/deal/DealForm.js